import React from 'react';
import Box from '@amzn/meridian/box';
import Row from '@amzn/meridian/row';
import Heading from '@amzn/meridian/heading';
import styles from './CCXDetailsPanel.module.css';
import { FormattedMessage } from 'react-intl';
import StarRating from '../../Util/generic/StarRating';

interface ICCXDetailsPanelProps {
  overall: number;
  knowledgeable: number;
  efficiency: number;
  helpfulness: number;
  empathy: number;
  courtesy: number;
  understandability: number;
}

const CCXDetailsPanel: React.FC<ICCXDetailsPanelProps> = ({
  overall,
  knowledgeable,
  efficiency,
  helpfulness,
  empathy,
  courtesy,
  understandability,
}) => {
  const renderStarsWithLabel = (label: string, stars: number) => (
    <div className={styles.inlineStars}>
      <div className={styles.inlineStarsLabel}>
        <FormattedMessage
          id={`cs_perfportal_ccx_panel_${label
            .toLowerCase()
            .replace(/ /g, '_')}`}
          defaultMessage={label}
        />
      </div>
      <div className={styles.inlineStarsIcons}>
        <StarRating
          iconStyles={styles.iconStyles}
          maxAmount={5}
          fillAmount={stars}
        />
      </div>
    </div>
  );

  return (
    <Box type='outline' spacingInset='400' width='445px' height='314px'>
      <Heading level={3} type='h300' className={styles.headingMargin}>
        <FormattedMessage
          id='cs_perfportal_ccx_panel_heading'
          description='CCX panel heading'
          defaultMessage='CCX'
        />
      </Heading>
      <Row>{renderStarsWithLabel('CCX overall', overall)}</Row>
      <Row>{renderStarsWithLabel('Knowledgeable', knowledgeable)}</Row>
      <Row>{renderStarsWithLabel('Efficiency', efficiency)}</Row>
      <Row>{renderStarsWithLabel('Helpfulness', helpfulness)}</Row>
      <Row>{renderStarsWithLabel('Empathy', empathy)}</Row>
      <Row>{renderStarsWithLabel('Courtesy', courtesy)}</Row>
      <Row>{renderStarsWithLabel('Understandability', understandability)}</Row>
    </Box>
  );
};

export default CCXDetailsPanel;
